module.exports = __webpack_public_path__ + "img/lou_grotta.a4b7a28b.png";